import FlexPane from './_flex-pane.js'
import Button from './_button.js'
import Image from './_image.js'
import Text from './_text.js'
import LegView from './_leg-view.js'
import StakeInfo from './_stake-info.js'
import PayoutInfo from './_payout-info.js'
import BetBonusPromotions from './_bet-bonus-promotions.js'
import OddsBoostNotification from './_odds-boost-notification.js'
import FormattedLabelWithTotalOdds from './_formatted-label-with-total-odds.js'

export default {
  name: 'BetView',
  values: {
    hideBetFunds: false,
    hideBetHeader: false,
    showTotalStakeLabel: true,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    baseOddsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'center',
          padding: '17px 0 0 0',
        },
      },
    },
    checkButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            padding: '0 8px 0 0',
          },
        },
      },
    },
    checkButtonImage: {
      configSet: Image,
      configValues: {
        src: 'check',
        style: {
          minWidth: '8px',
          minHeight: '8px',
        },
      },
    },
    checkButtonImageContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          minWidth: '16px',
          minHeight: '16px',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
    },
    header: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 8px 0',
        },
      },
    },
    legsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          padding: '8px 0 0 0',
        },
      },
    },
    leg: {
      configSet: LegView,
      configValues: {},
    },
    fundsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    stakeInfo: {
      configSet: StakeInfo,
      configValues: {},
    },
    payoutInfo: {
      configSet: PayoutInfo,
      configValues: {},
    },
    oddsBoostInfo: {
      configSet: PayoutInfo,
      configValues: {},
    },
    freeBetIcon: {
      configSet: Image,
      configValues: {
        src: 'freebet-filled',
        style: {
          minWidth: '16px',
          minHeight: '16px',
          padding: '0 4px 0 0',
        },
      },
    },
    bonusIcon: {
      configSet: Image,
      configValues: {
        src: 'prewager',
        style: {
          minWidth: '16px',
          minHeight: '16px',
          padding: '0 4px 0 0',
        },
      },
    },
    betBonusPromotions: {
      configSet: BetBonusPromotions,
      configValues: {},
    },
    oddsBoostNotification: {
      configSet: OddsBoostNotification,
      configValues: {
        container: {
          style: {
            padding: '0',
          },
        },
      },
    },
    totalOdds: {
      configSet: FormattedLabelWithTotalOdds,
      configValues: {
        container: {
          style: {
            padding: '0',
          },
        },
      },
    },
    totalOddsBoost: {
      configSet: FormattedLabelWithTotalOdds,
      configValues: {},
    },
    overaskChanged: {
      configSet: FormattedLabelWithTotalOdds,
      configValues: {
        priceBoostIndicator: undefined,
      },
    },
  },
  meta: {
    extendable: false,
  },
}
